import { useParams, useNavigate, Link } from "react-router-dom";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { Box, CircularProgress, Alert, Button } from "@mui/joy";
import ContractDesigner from "../../components/crm/contracts/ContractDesigner";
import { api } from "../../lib/api";
import type { Contract } from "../../types";
export const ContractDesignerPage = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const client = useQueryClient();
  const query = useQuery({
    queryKey: ["contract-design", id],
    queryFn: async () =>
      (await api.get<Contract>(`/api/crm/contracts/${id}/`)).data,
  });
  if (query.isPending) return <CircularProgress />;
  const contract = query.data;
  if (query.isError || !contract || String(contract.id) !== id)
    return (
      <Alert color="danger">
        Contract unavailable.{" "}
        <Button onClick={() => query.refetch()}>Retry</Button>
      </Alert>
    );
  if (contract.status !== "draft")
    return (
      <Box sx={{ p: 3 }}>
        <Alert>
          This contract is fixed after sending. Open its detail page to create a
          draft revision.
        </Alert>
        <Button component={Link} to={`/crm/contracts/${contract.id}`}>
          Open contract
        </Button>
      </Box>
    );
  return (
    <ContractDesigner
      key={contract.id}
      contract={contract}
      contractId={contract.id}
      onSave={async (updated) => {
        const saved = await api.patch<Contract>(`/api/crm/contracts/${contract.id}/`, {
          title: updated.title,
          contract_fields: updated.contract_fields,
          total_value: updated.total_value,
        });
        client.setQueryData(["contract-detail", String(contract.id)], saved.data);
        client.setQueryData(["contract-design", String(contract.id)], saved.data);
        await client.invalidateQueries({ queryKey: ["contract-workflow", String(contract.id)] });
        navigate(`/crm/contracts/${contract.id}`);
      }}
      onCancel={() => navigate(`/crm/contracts/${contract.id}`)}
    />
  );
};
